export default __webpack_public_path__ + "static/media/NF.2aa275f0.ico";